import { render, staticRenderFns } from "./FeedEventReactionDetails.vue?vue&type=template&id=34be470c&scoped=true"
import script from "./FeedEventReactionDetails.vue?vue&type=script&lang=js"
export * from "./FeedEventReactionDetails.vue?vue&type=script&lang=js"
import style0 from "./FeedEventReactionDetails.vue?vue&type=style&index=0&id=34be470c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34be470c",
  null
  
)

export default component.exports